var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('router-view')],1),_c('notifications',{staticStyle:{"top":"84px"},attrs:{"group":"notify-group","width":"350","position":"top center"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }